enum ProfilePictureSizeEnum {
  Size30 = 'SIZE30',
  Size38 = 'SIZE38',
  Size41 = 'SIZE41',
  Size50 = 'SIZE50',
  Size76 = 'SIZE76',
  Size120 = 'SIZE120',
}

export default ProfilePictureSizeEnum;
